<div>
    <figure (click)="clickSelect.emit(version)">
      <em></em>
      <core-version-preview [format]="'min'" [version]="version"></core-version-preview>
    </figure>
    <span>{{title}}</span>
</div>
